import React, { memo, useState } from 'react'
import styles from './PublicLayoutLanding.module.scss'
import { Outlet } from 'react-router-dom'
import Header from './components/LandingPageHeader'
import Footer from './components/Footer'
import GetSolarPower from './components/GetSolarPower'
import PublicSideMenu from '../components/public-side-menu/PublicSideMenu'

type Props = {}

const PublicLayoutProducts: React.FC<Props> = memo((props: Props) => {
    const [menuOpen, setMenuOpen] = useState(false);

    function handleMenuButtonClick() {
        setMenuOpen(!menuOpen);
    }

    return (
        <>
            <Header onMenuButtonClick={handleMenuButtonClick} />
            <div className={styles.container}>
                <Outlet />
            </div>
            <GetSolarPower />
            {/* <Footer /> */}
            <PublicSideMenu menuOpen={menuOpen} closeMenu={handleMenuButtonClick} />
        </>
    )
})

export default PublicLayoutProducts